<template>
  <div class="wrap">
    <h2 class="common-header">{{ $t('3') }}</h2>
    <div class="by-content">
      <el-form :inline="true" :model="dataForm">
        <!-- 姓名 -->
        <el-form-item :label="$t('22')">
          <el-input
            class="search_name"
            v-model="dataForm.search_name"
            :placeholder="`${$t('22')}、${$t('25')}、${$t('825')}`"
          ></el-input>
        </el-form-item>
        <!-- 部门 -->
        <el-form-item :label="$t('27')">
          <el-popover v-model="popover" width="100%" ref="treePopover" placement="bottom" trigger="click">
            <dep-tree @node-click="handleNodeClick"></dep-tree>
          </el-popover>
          <el-input
            v-model="depInfo.name"
            v-popover:treePopover
            :placeholder="$t('19')"
            clearable
            @clear="departmentClear"
          ></el-input>
        </el-form-item>
        <!-- 职位 -->
        <el-form-item :label="$t('24')">
          <el-select
            v-model="dataForm.job_title_id"
            filterable
            remote
            reserve-keyword
            clearable
            :placeholder="$t('90')"
            :remote-method="remoteMethod"
          >
            <el-option v-for="item in posiOptions" :key="item.id" :label="item.job_title_name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 入职日期 -->
        <el-form-item :label="$t('28')">
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="-"
            :start-placeholder="$t('407')"
            :end-placeholder="$t('408')"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 员工状态 -->
        <el-form-item :label="$t('31')">
          <el-select v-model="dataForm.state" :placeholder="$t('799')" clearable multiple>
            <el-option
              v-for="(item, index) in sysInfoArr.state"
              :key="index"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 员工属性 -->
        <el-form-item :label="$t('32')">
          <el-select v-model="dataForm.formal" :placeholder="$t('800')" clearable>
            <el-option
              v-for="(item, index) in sysInfoArr.formal"
              :key="index"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 直线上级 -->
        <el-form-item :label="$t('980')">
          <el-select
            v-model="dataForm.manager_id"
            filterable
            remote
            reserve-keyword
            clearable
            :placeholder="$t('90')"
            :remote-method="supRemoteMethod"
            :loading="supLoading"
          >
            <el-option
              v-for="item in supOptions"
              :key="item.staff_id"
              :label="item.staff_name"
              :value="item.staff_id"
              class="cstom-options"
            >
              <div>
                <img :src="item.avatar_url || getAvatar(0)" alt="" />
                <div>
                  <p style="font-size: 14px">{{ item.staff_name }}</p>
                  <p style="font-size: 12px">{{ item.staff_name_secondary }}</p>
                </div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 工作地点 -->
        <el-form-item :label="$t('1020')">
          <el-input v-model="dataForm.work_address" :placeholder="$t('90')"></el-input>
        </el-form-item>
        <!-- 查询 -->
        <el-form-item>
          <el-button type="primary" plain @click="getTableData">{{ $t('80') }}</el-button>
        </el-form-item>
        <!-- 部门调整 -->
        <div class="org-active">
          <!-- disabled 状态下增加提示 -->
          <!-- 一键邀请 -->
          <el-tooltip effect="dark" :content="$t('dc268f1d')" placement="bottom-start" v-if="dsInvite">
            <el-button :class="{ 'is-disabled': dsInvite }" type="primary" plain>{{ $t('1759') }}</el-button>
          </el-tooltip>
          <el-button v-else type="primary" plain @click="invite()">{{ $t('1759') }}</el-button>
          <!-- 添加成员 -->
          <el-button type="primary" plain @click="addOrUpdate()" v-if="$p('menu.org.per.edit')">{{
            $t('344')
          }}</el-button>
          <!-- 调整部门 -->
          <el-button
            type="primary"
            plain
            :disabled="!tableSelectArr.length"
            @click="depAdjustHandle"
            v-if="$p('menu.org.per.edit')"
          >
            {{ $t('20') }}
          </el-button>
          <!-- 批量导入/修改 -->
          <el-button type="primary" plain @click="openUpload()" v-if="$p('menu.org.per.edit')">{{
            $t('14')
          }}</el-button>
          <!-- 批量导出 -->
          <el-button type="primary" plain @click="batchExport" v-if="$p('menu.org.per.export')">{{
            $t('68')
          }}</el-button>
        </div>
      </el-form>
      <el-alert :title="$t('1762', { x: NoRegisterNum })" type="warning" :closable="false" show-icon>
        <el-link type="primary" :underline="false" @click="exportNoRegister" v-if="$p('menu.org.per.export')">{{
          $t('68')
        }}</el-link>
      </el-alert>
      <el-table
        ref="tableList"
        :data="page.list"
        :height="tableHeight"
        v-load="tableLoading"
        @selection-change="tableSelectHandle"
        :loading-text="$t('989')"
        @sort-change="handlerSort"
      >
        <el-table-column type="selection" width="65" align="center"></el-table-column>
        <el-table-column
          sortable="custom"
          prop="staff_code"
          :label="$t('25')"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="staff_name_th"
          sortable="custom"
          :label="$t('22')"
          width="200"
          align="center"
        ></el-table-column>
        <!-- 英文姓名 -->
        <el-table-column
          prop="staff_name_en"
          sortable="custom"
          :label="$t('dep_2')"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column prop="is_register_user" :label="$t('1421')" width="200" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.is_register_user === '1'" class="icon icon-success">
              <img :src="successImg" alt="" /><span>{{ $t('1422') }}</span>
            </div>
            <div v-if="scope.row.is_register_user === '0'" class="icon icon-important">
              <img :src="noImportantImg" alt="" /><span>{{ $t('1423') }}</span>
            </div>
            <div v-if="scope.row.is_register_user === '2'" class="icon icon-warning">
              <img :src="cancelImg" alt="" /><span>{{ $t('i18n.fca49ee1daf340a3b59597d849d7f096') }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" :label="$t('23')" width="200" align="center"></el-table-column>
        <el-table-column prop="department_name" :label="$t('27')" width="200" align="center"></el-table-column>
        <el-table-column prop="job_title_name" :label="$t('24')" width="200" align="center"></el-table-column>
        <el-table-column prop="state_name" :label="$t('31')" width="200" align="center"></el-table-column>
        <el-table-column prop="formal_name" :label="$t('32')" width="200" align="center"></el-table-column>
        <el-table-column prop="manager_name" :label="$t('980')" width="200" align="center"></el-table-column>
        <el-table-column
          prop="hire_date"
          sortable="custom"
          :label="$t('28')"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column prop="leave_date" :label="$t('29')" width="200" align="center" sortable="custom">
          <template slot="header">
            {{ $t('29') }}
            <el-tooltip class="item" effect="dark" :content="$t('i18n.7Y1RdNWcszSG')" placement="top-start">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="formal_date" :label="$t('30')" width="200" align="center"></el-table-column>
        <!-- 个人邮箱 -->
        <el-table-column
          prop="personal_email"
          :label="$t('personal_email')"
          width="200"
          align="center"
        ></el-table-column>
        <!-- 企业邮箱 -->
        <el-table-column
          prop="enterprise_email"
          :label="$t('business_mailbox')"
          width="200"
          align="center"
        ></el-table-column>
        <!-- line_id -->
        <el-table-column prop="line_id" label="LINE-ID" width="200" align="center"></el-table-column>
        <!-- 备注 -->
        <el-table-column prop="remark" :label="$t('1602')" width="200" align="center"></el-table-column>
        <el-table-column prop="settlement_type_name" :label="$t('33')" width="200" align="center"></el-table-column>
        <el-table-column prop="salary_method_name" :label="$t('34')" width="200" align="center"></el-table-column>
        <el-table-column :label="$t('70')" width="200" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="view(row)">
              {{ $t('64') }}
            </el-button>
            <el-button type="text" @click="addOrUpdate(row)" v-if="$p('menu.org.per.edit')">
              {{ $t('71') }}
            </el-button>
            <el-button
              type="text"
              @click="getStaffAuditResign(row)"
              :disabled="['2', '3'].includes(row.state)"
              v-if="$p('menu.org.per.delete')"
            >
              {{ $t('leave_office') }}
            </el-button>
            <el-button type="text" @click="deleteStaff(row)" v-if="$p('menu.org.per.delete')">
              {{ $t('65') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="page-wrap"
        layout="total, sizes, prev, pager, next"
        :page-sizes="pageSizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :total="page.total"
        :current-page="page.currPage"
        :page-size="page.limit"
        background
      >
      </el-pagination>
    </div>
    <add-or-update
      v-if="isAddOrUpdate"
      ref="addOrUpdate"
      :sys-info-arr="sysInfoArr"
      :posi-all-list="posiAllList"
      :operate-type="operateType"
      @refreshTableList="getTableData"
    ></add-or-update>
    <!-- 调整部门 -->
    <dep-adjust ref="depAdjust" v-if="isDepAdjust" @refreshDataList="getTableData"></dep-adjust>
    <!-- 批量导入 -->
    <uploadTab ref="uploadTab" />
    <exportList ref="exportList" @operate="exportData" />
    <invite
      ref="invite"
      :tableSelectArr="tableSelectArr"
      @refreshDataList="getTableData"
      v-if="isInvite"
      @refreshTime="handleCountDown"
    />
    <!-- 离职 -->
    <leave-office ref="leaveOffice" v-if="isLeaveOffice" @refreshTableList="getTableData" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import addOrUpdate from './add-or-update'
import { listUrlFn, sysInfoFn, exportData, searchStaffFn } from '@/api/org/per'
import { deleteStaffFun, getInviteStaffData, getStaffAuditResign } from '@/api/org/staff'
import { getAvatar } from '@/util/util'
import { getAllListFn } from 'api/org/position'
import depTree from '@/components/dep-tree'
// 调整部门
import depAdjust from './dep-adjust'
// 批量倒入修改
import uploadTab from './uploadTab'
// 一键邀请
import invite from './invite'
import exportList from './export.vue'
import leaveOffice from './leaveOffice.vue'

import store from 'storejs'

export default {
  components: {
    addOrUpdate,
    depTree,
    depAdjust,
    uploadTab,
    invite,
    exportList,
    leaveOffice
  },
  data() {
    return {
      successImg: require('@/assets/img/success_icon.png'),
      noImportantImg: require('@/assets/img/noImportant_icon.png'),
      cancelImg: require('@/assets/img/cancel-icon.png'),
      tableSelectArr: [],
      posiOptions: [],
      dataForm: {},
      date: '',
      pageSizes: [100, 50, 20],
      isDepAdjust: false,
      page: {
        list: [],
        currPage: 1,
        limit: 100,
        total: 0
      },
      sort: '',
      dir: '',
      tableLoading: false,
      isAddOrUpdate: false,
      popover: false,
      depInfo: {},
      posiAllList: [],
      sysInfoArr: {
        state: [], // 在职状态 1-在职 2-离职 3-待离职 4-停职
        salary_method: [], // 发薪方式
        settlement_type: [], // 结算类型
        formal: [] // 员工属性
      },
      // 俩分钟内不可重复邀请
      dsInvite: false,
      isInvite: false,
      isLeaveOffice: false,
      operateType: '',
      NoRegisterNum: 0,
      staffInfo: {},
      supLoading: false,
      supOptions: [],
      getAvatar
    }
  },
  computed: {
    ...mapState({
      contentViewHeight: state => state.settings.contentViewHeight
    }),
    tableHeight() {
      return this.contentViewHeight - 260
    }
  },
  mounted() {
    this.sysInfoFn()
    this.getAllListFn()
    this.getTableData()
    this.getNoRegisterNum()
    this.handleCountDown()
  },
  methods: {
    // 倒计时邀请 2分钟之内无法再次邀请
    handleCountDown() {
      const time = store.get('invalid-time')
      const loop = setInterval(() => {
        this.dsInvite = Date.now() - time < 120000
        if (!this.dsInvite) clearInterval(loop)
      }, 1000)
    },
    // 排序
    handlerSort({ prop, order }) {
      this.sort = prop
      this.dir = order
      this.getTableData()
    },
    // 数据导出
    batchExport() {
      this.$refs.exportList.init()
    },
    async exportData(columns) {
      const [begin_hire_date, end_hire_date] = this.date || [null, null]
      const res = await exportData({
        ...this.dataForm,
        begin_hire_date,
        end_hire_date,
        columns
      })
      window.location.href = res.data.down_load_excel.object_url
      this.$refs.exportList.visible = false
    },
    // 表格选择
    tableSelectHandle(val) {
      this.tableSelectArr = val
    },
    // 部门人员 调整部门
    depAdjustHandle() {
      this.isDepAdjust = true
      this.$nextTick(() => this.$refs.depAdjust.init(this.tableSelectArr.map(v => v.staff_id)))
    },
    // 批量导入
    openUpload() {
      this.$refs.uploadTab.init()
    },
    async sysInfoFn() {
      const res = await sysInfoFn()
      if (res && res.code === 1) this.sysInfoArr = res.data
    },
    handleNodeClick(val) {
      this.depInfo.name = val.department_name
      this.dataForm.department_id = val.department_id
      this.popover = false
    },
    remoteMethod(query) {
      const obj = this.posiAllList.filter(v => v.job_title_name.toLowerCase().indexOf(query.toLowerCase()) > -1)
      this.posiOptions = query !== '' ? obj : []
    },
    async getAllListFn() {
      const res = await getAllListFn()
      this.posiAllList = res.data
    },
    async getTableData() {
      const [begin_hire_date, end_hire_date] = this.date || [null, null]
      this.tableLoading = true
      const res = await listUrlFn({
        ...this.dataForm,
        page: this.page.currPage,
        page_size: this.page.limit,
        begin_hire_date,
        sort: this.sort, // 排序相关
        dir: this.dir,
        end_hire_date
      })
      this.tableLoading = false
      if (res && res.code === 1) {
        this.page.list = res.data.rows
        this.$nextTick(() => {
          this.$refs.tableList && this.$refs.tableList.doLayout()
        })
        this.page.total = res.data.total_count
      }
    },
    // 每页条数
    sizeChangeHandle(val) {
      this.page.limit = val
      this.getTableData()
    },
    // 切换 页
    currentChangeHandle(val) {
      this.page.currPage = val
      this.getTableData()
    },
    addOrUpdate(item) {
      this.operateType = !item ? 'create' : 'edit'
      this.isAddOrUpdate = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(item || null)
      })
    },
    view(item) {
      this.operateType = 'view'
      this.isAddOrUpdate = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(item || null)
      })
    },
    departmentClear() {
      this.dataForm.department_id = null
    },
    // 是否有离职审批流
    async getStaffAuditResign(item) {
      this.staffInfo = {
        staff_id: item.staff_id,
        staff_name: item.staff_name,
        formal_name: item.formal_name,
        hire_date: item.hire_date
      }
      const res = await getStaffAuditResign({ staff_id: item.staff_id })
      if (res.data) {
        this.$confirm(this.$t('2000'), this.$t('229'), {
          confirmButtonText: this.$t('131'),
          cancelButtonText: this.$t('66')
          // type: 'warning'
        }).then(() => {
          this.leaveOffice(this.staffInfo)
        })
      } else {
        this.leaveOffice(this.staffInfo)
      }
    },
    // 离职
    async leaveOffice() {
      this.isLeaveOffice = true
      this.$nextTick(() => this.$refs.leaveOffice.init(this.staffInfo || null))
    },
    // 删除
    deleteStaff(staffInfo) {
      this.$confirm(this.$t('confirm_delete'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(() => {
        deleteStaffFun(staffInfo).then(() => {
          this.$notify({
            title: this.$t('229'),
            message: this.$t('806'),
            type: 'success'
          })
          this.getTableData()
        })
      })
    },
    invite() {
      if (this.dsInvite) return
      this.isInvite = true
      this.$nextTick(() => this.$refs.invite.init())
    },
    async getNoRegisterNum() {
      await getInviteStaffData().then(res => {
        if (res && res.code === 1) {
          this.NoRegisterNum = res.data.no_register_staff_count
        }
      })
    },
    // 数据导出
    async exportNoRegister() {
      const res = await exportData({ is_register_user: 0 })
      window.location.href = res.data.down_load_excel.object_url
    },
    // 直线上级搜索
    supRemoteMethod(query) {
      if (query !== '') {
        this.supLoading = true
        // ajax请求
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          searchStaffFn({
            search_name: query,
            page_size: 20
          }).then(res => {
            this.supLoading = false
            if (res && res.code === 1) {
              this.supOptions = res.data
            }
          })
        }, 300)
      } else {
        this.supOptions = []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.org-active {
  text-align: right;
  margin-bottom: 20px;
}
/deep/.el-alert__content {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  .el-alert__description {
    margin: 0px 0px 0px 18px;
  }
}
.icon {
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 14px;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  img {
    width: 14px;
    height: 14px;
    margin: 4px;
  }
}
.icon-important {
  background: rgba(176, 95, 225, 0.2);
  color: #b05fe1;
}
.icon-success {
  background: rgba(102, 145, 247, 0.2);
  color: #6691f7;
}
.icon-warning {
  background-color: #ffdfdf;
  color: #ff4d4f;
}
/deep/.el-alert__icon.is-big {
  width: 20px;
  font-size: 17px;
}
.search_name {
  min-width: 320px;
}
.cstom-options {
  height: auto !important;
  > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    > img {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      object-fit: cover;
      overflow: hidden;
      border: none;
    }
    > div {
      width: calc(100% - 40px);
      > p {
        height: 28px;
      }
    }
  }
}
</style>
